module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Stamp-ae3980e694f51e9ed56193c24c9f9978c12aa257532342e78af76eb568a828e3.svg";